/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TagesplanDto } from '../../models/tagesplan-dto';

export interface GetTagesplan$Json$Params {

/**
 * ID des Tagesplan nach der gesucht werden soll
 */
  id: string;
}

export function getTagesplan$Json(http: HttpClient, rootUrl: string, params: GetTagesplan$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<TagesplanDto>> {
  const rb = new RequestBuilder(rootUrl, getTagesplan$Json.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TagesplanDto>;
    })
  );
}

getTagesplan$Json.PATH = '/v1/tagesplaene/{id}';
